module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// TipsMenuChecker Widget

(function (fox, $) {
	
	fox.registerWidget('TipsMenuChecker', {

		configure: function () {
			this.registerOptions('', {
				widgets: {
					api: {
						widget: 'Api',
						method: 'tips.getTipsCount',
						cacheChannel: 'site',
						sendTimezone: true
					}
				},
				handleWom: {
					apiSuccess: {
						event: ['success', 'failure', 'error'],
						widget: '#api',
						callback: 'apiSuccess'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		apiSuccess: function (res) {
			res = res.answer.response;

			if (res > 0) {
				this.ml.render();
			}
		},

		init: function () {
			this.embedMenuLink();		
		
			this.callParent('init', arguments);
		},

		running: function () {
			this.ml = this.rwom1('#menuLink');
			this.ml._readyToRender = false;

			this.rwom1('#api').send();
		
			this.callParent('running', arguments);
		},

		embedMenuLink: function () {
			this.embedWidget('menuLink', 'Widget', fox.merge({
				autoRender: false,
				template: 'layout_tips_menu',
				'embed.location': 'under'
			}, this.getOption('menuLink')));

			return this;
		}

	}, 'Controller');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/tipsChecker.js
// module id = 919
// module chunks = 4